import './NamePill.css';

export default function NamePill({
  text,
  showGlow = false,
  align = 'start',
  className = '',
}) {
  if (!text) return null;

  const classes = [
    'NamePill',
    `NamePill--${align}`,
    showGlow ? 'NamePill--glow' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes}>
      <span className="NamePill__text">{text}</span>
    </div>
  );
}
